import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import MapOutlined from '@mui/icons-material/MapOutlined';
import {
  MaterialReactTable,
  useMaterialReactTable,
} from 'material-react-table'
import { getDefaultMRTOptions, TABLE_COLS, isArrayNonEmptySubset } from '../constants';

export default function SelectedRoadsTable({fromToTable, setFromToTable, mapRef, showOnMapData, setShowOnMapData}) {

  const table = useMaterialReactTable(
    {
    ...getDefaultMRTOptions,
    columns: TABLE_COLS, // different from Summary table columns
    data: fromToTable,
    enableGrouping: false,
    enableExpanding: true,
    filterFromLeafRows: true,
    renderEmptyRowsFallback: () => (
      <Typography component='i' color='textSecondary'>No rows. Select the segments using the 'From here' and 'To here' buttons to add selected roads.</Typography>
    ),
    initialState: { ...getDefaultMRTOptions.initialState },
    muiTablePaperProps: {
      id: 'ILMAT_Selected_Roads'
    },
    defaultColumn: {
      AggregatedCell: ({cell}) => <>{Number.isNaN(cell.getValue()) ? '' : cell.getValue() }</>
    },
    muiTableHeadRowProps: ({}) => ({
      sx: (theme) => ({
        '& th': {
          borderLeft: `1px solid ${theme.palette.divider}`,
          borderRight: `1px solid ${theme.palette.divider}`, 
        },
      }),
    }),
    muiTableBodyRowProps: ({row}) => ({
      sx: (theme) => ({
        '& td': {
          color: ( row.depth === 0
            ? isArrayNonEmptySubset(showOnMapData, row.subRows.map(d => d.original.id))
            : showOnMapData.includes(row.original.id)
          ) ? 'red' : theme.palette.text.primary,
          fontWeight: showOnMapData.includes(row.original.id) ? 'bold' : 'normal',
          borderLeft: '1px solid ' + theme.palette.divider,
          borderRight: '1px solid ' + theme.palette.divider,
        }
      })
    }),
    renderRowActions: ({row}) => (
      <>
        { row.depth === 0 &&
          <Tooltip title='Delete' placement='left'>
            <IconButton 
            aria-label='delete'
            color='inherit'
            onClick={() => {
              setFromToTable(prevTable => prevTable.filter((_, prevRowIndex) => prevRowIndex !== row.index))
              const subRowIDs = row.subRows.map(d => d.original.id)
              setShowOnMapData(prev => prev.filter(p => !subRowIDs.includes(p)))
            }}>
              <DeleteOutlineIcon fontSize='medium' />
            </IconButton>
          </Tooltip>
        }
        { row.depth === 0 ?
          <Tooltip title={isArrayNonEmptySubset(showOnMapData, row.subRows.map(d => d.original.id)) ? 'Undo' : 'Show on map'} placement='right'>
            <IconButton
              color='inherit'
              onClick={() => {
                const subRowIDs = row.subRows.map(d => d.original.id)
                if (isArrayNonEmptySubset(showOnMapData, subRowIDs)) {
                  setShowOnMapData(prev => prev.filter(p => !subRowIDs.includes(p)))
                } else {
                  setShowOnMapData(prev => [...prev, ...subRowIDs])
                }
              }}
            >
              <MapOutlined />
            </IconButton>
          </Tooltip>
          : <Tooltip title={showOnMapData.includes(row.original.id) ? 'Undo' : 'Show on map'} placement='right'>
            <IconButton
              color='inherit'
              onClick={() => {
                if (showOnMapData.includes(row.original.id)) {
                  setShowOnMapData(prev => prev.filter(p => p !== row.original.id))
                } else {
                  setShowOnMapData(prev => [...prev, row.original.id])
                }
              }}
            >
              <MapOutlined />
            </IconButton>
          </Tooltip>
        }
      </>
    )
   }
);

  return <MaterialReactTable table={table} />;

}